const FALLBACK_GROUP_LABEL = "Other Locations";

export function getLocationGroupLabel(locationName) {
  const name = (locationName || "").trim();
  return name || FALLBACK_GROUP_LABEL;
}

export function groupLocationsForDropdown(locations) {
  const buckets = new Map();

  locations.forEach((location) => {
    const groupLabel = getLocationGroupLabel(location.category);
    if (!buckets.has(groupLabel)) buckets.set(groupLabel, []);
    buckets.get(groupLabel).push(location);
  });

  return Array.from(buckets.entries()).map(([label, options]) => ({
    label,
    options: options.sort((a, b) => a.name.localeCompare(b.name)),
  }));
}

export function formatLocationOption(location) {
  const fee = Number.parseFloat(location.delivery_fee || 0);
  return `${location.name} — ${fee === 0 ? "Free delivery" : `RM ${fee.toFixed(2)} delivery`}`;
}